import {
    Component,
    Input,
    HostBinding,
    Output,
    EventEmitter
} from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import {
    ShowDlgTransferService
} from '../../shared-dialogs.module/show-dlg-transfer.service';
import {
    ITEM_SHOP_URL,
    CPU_LIFETIME_STORE_URL
} from '../store-urls';

@Component({
    selector: 'app-store-cpu-unlock',
    templateUrl: './store-cpu-unlock.component.pug',
    styleUrls: ['./store-cpu-unlock.component.less']
})
export class StoreCpuUnlockComponent {
    @HostBinding('class.--ui') _ui = true;

    itemShopUrl = ITEM_SHOP_URL;
    lifetimeStoreUrl = CPU_LIFETIME_STORE_URL;

    @HostBinding('attr.disabled') disabled;

    @Input() steam: any;
    @Input() lifetimeSubscription: boolean = false;

    _amountSbj: BehaviorSubject<number> = new BehaviorSubject(0);
    amount$: Observable<number> = this._amountSbj.asObservable();
    @Input() set amount(amount: number) {
        this._amountSbj.next(amount >= 0 ? amount : 0);
    }

    @Output() close: EventEmitter<any> = new EventEmitter();
    @Output() transfer: EventEmitter<any> = new EventEmitter();
    @Output() activate: EventEmitter<any> = new EventEmitter();

    constructor(
        private _dlgTransferSrv: ShowDlgTransferService,
    ) {
    }

    onClose() {
        this.close.emit();
    }

    async onTransfer() {
        this._disable();

        let count;
        try {
            count = await this._dlgTransferSrv.show({
                limit: this._amountSbj.getValue(),
                title: 'How many <span class="--color-text-cpu-unlock">CPU Unlocks</span> do you want to transfer?',
                button: 'Transfer&nbsp;<app-icon-cpu-unlock></app-icon-cpu-unlock>&nbsp;to Steam'
            });
        } catch (err) {
            console.debug('StoreCpuUnlockComponent::onTransfer', err);

            this._enable();
            return;
        }

        this.transfer.emit(count);
    }

    async onActivate() {
        this._disable();

        let count;
        try {
            count = await this._dlgTransferSrv.show({
                limit: this._amountSbj.getValue(),
                title: 'How many <span class="--color-text-cpu-unlock">CPU Unlocks</span> do you want to activate?',
                button: 'Activate&nbsp;<app-icon-cpu-unlock></app-icon-cpu-unlock>&nbsp;'
            });
        } catch (err) {
            console.debug('StoreCpuUnlockComponent::onACtivate', err);

            this._enable();
            return;
        }

        this.activate.emit(count);
    }

    _disable() {
        this.disabled = true;
    }

    _enable() {
        this.disabled = false;
    }
}
